import { Modal } from 'antd';
import PropTypes from 'prop-types';
import { logoff } from './services/repository/userPoliciesRepository';
import { setupAuthErrorInterceptor } from './services/util/http';

function AuthErrorProvider({ children }) {
  setupAuthErrorInterceptor({
    handleAuthenticationError: () => logoff(),
    handleAuthorizationError: (authorizationDeniedMessage) =>
      Modal.error({
        title: 'Acesso Negado',
        content: authorizationDeniedMessage,
        centered: true,
      }),
  });

  return children;
}

AuthErrorProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthErrorProvider;
